import React from 'react';
import { PropTypes } from 'prop-types';
import { alpha, Chip as MuiChip, makeStyles } from '@material-ui/core';
import { palette } from '../../settings/themes/colors';

const useFilterChipStyles = makeStyles(() => ({
  root: {
    borderRadius: 8,
    border: `1px solid ${alpha(palette.dimGray, 0.2)}`,
    backgroundColor: palette.white,
    color: palette.dimGray,
    fontWeight: 'bold',
    width: 'fit-content'
  },
  deleteIcon: {
    color: palette.dimGray,
    '&:hover': {
      color: palette.cerulean
    }
  }
}));

export const FilterChip = ({ label, onDelete, ...props }) => {
  const classes = useFilterChipStyles();

  return <MuiChip classes={classes} size="small" label={label} onDelete={onDelete} {...props} />;
};

FilterChip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
  onDelete: PropTypes.func
};
